import { FC, useState } from 'react'

import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded'
import {
  TableHeadStyled,
  TableCellStyled,
  TableContainerStyled,
  TableRowStyled,
  TableStyled,
  TableBodyStyled,
  TableFooter
} from 'components'
import {
  DeleteIcon,
  EditIcon,
  WatchCancelIcon,
  WatchCheckIcon
} from 'components/Icons'
import { useLoading, useModal } from 'hooks'
import { IHandleChangePage, IHandleChangeRowsPerPage } from 'hooks/useGet'
import { JobsService, IGetAllJobsResponse } from 'services/GST/Jobs'
import { SPACING } from 'utils'

interface ITableJobsProps {
  tableData: IGetAllJobsResponse[]
  setJob: React.Dispatch<React.SetStateAction<IGetAllJobsResponse>>
  toggleRefreshScreen: () => void
  toggleModalEditJobs: () => void
  setIsConsult: (_action: boolean) => void
}

const TableJobs: FC<ITableJobsProps> = ({
  tableData,
  setJob,
  toggleModalEditJobs,
  toggleRefreshScreen,
  setIsConsult
}) => {
  const { showModal } = useModal()
  const { setLoading } = useLoading()

  const handleDeleteJob = (idHangfireJob: string, nmJob: string) => {
    showModal({
      handleConfirm: () => handleChangeStateDeleteJob(idHangfireJob),
      message: `Excluir JOB ${nmJob}?`,
      txtButtonCancel: 'NÃO',
      txtButtonConfirm: 'SIM',
      type: 'alert'
    })
  }

  const handleChangeStateDeleteJob = (idHangfireJob: string) => {
    setLoading('loading')
    JobsService()
      .deleteJob(idHangfireJob)
      .then((response) => {
        if (response.status === 200) {
          showModal({
            hideButtonCancel: true,
            message: 'Job deletado com sucesso!',
            txtButtonConfirm: 'OK',
            type: 'success'
          })

          toggleRefreshScreen()
        }
      })
      .catch((response) => {
        showModal({
          hideButtonCancel: true,
          message:
            response.detail || 'Não foi possível deletar Job, tente novamente!',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
    setLoading('idle')
  }

  const handleStopJobPlanning = (idHangfireJob: string, nmJob: string) => {
    showModal({
      handleConfirm: () => handleChangeStateJob(idHangfireJob, false),
      message: `Deseja parar o planejamento do JOB ${nmJob}?`,
      txtButtonCancel: 'NÃO',
      txtButtonConfirm: 'SIM',
      type: 'alert'
    })
  }

  const handleStartJobPlanning = (idHangfireJob: string, nmJob: string) => {
    showModal({
      handleConfirm: () => handleChangeStateJob(idHangfireJob, true),
      message: `Deseja ativar o planejamento do JOB ${nmJob}?`,
      txtButtonCancel: 'NÃO',
      txtButtonConfirm: 'SIM',
      type: 'alert'
    })
  }

  const handleChangeStateJob = (idHangfireJob: string, flAtivo: boolean) => {
    setLoading('loading')
    const sucessMessage = flAtivo ? 'Job ativado!' : 'Job desativado!'

    JobsService()
      .suspender(idHangfireJob, flAtivo)
      .then((response) => {
        if (response.status === 200) {
          showModal({
            hideButtonCancel: true,
            message: sucessMessage,
            txtButtonConfirm: 'OK',
            type: 'success'
          })

          toggleRefreshScreen()
        }
      })
      .catch(() => {
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível alterar Status do Job, tente novamente!',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
    setLoading('idle')
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled>Jobs</TableCellStyled>
              <TableCellStyled padding="checkbox" align="center">
                Tipo
              </TableCellStyled>
              <TableCellStyled align="center">Ações</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.map((row) => (
              <TableRowStyled key={row?.idJob}>
                <TableCellStyled>{row?.nmJob}</TableCellStyled>
                <TableCellStyled align="center">
                  {row?.jobInfo?.txTipoRecorrencia}
                </TableCellStyled>
                <TableCellStyled 
                  style={{ 
                    alignContent: 'center', 
                    display: 'flex', 
                    justifyContent: 'center' 
                  }}
                >
                  <VisibilityRoundedIcon
                    onClick={() => {
                      setIsConsult(true)
                      setJob(row)
                      toggleModalEditJobs()
                    }}
                    cursor="pointer"
                  />
                  <EditIcon
                    marginLeft={SPACING.spacing5}
                    onClick={() => {
                      setJob(row)
                      toggleModalEditJobs()
                    }}
                    cursor="pointer"
                  />
                  {row.flAtivo ? (
                    <WatchCheckIcon
                      onClick={() =>
                        handleStopJobPlanning(row?.idHangfireJob, row?.nmJob)
                      }
                      marginRight={SPACING.spacing5}
                      marginLeft={SPACING.spacing5}
                      cursor="pointer"
                    />
                  ) : (
                    <WatchCancelIcon
                      onClick={() =>
                        handleStartJobPlanning(row?.idHangfireJob, row?.nmJob)
                      }
                      marginRight={SPACING.spacing5}
                      marginLeft={SPACING.spacing5}
                      cursor="pointer"
                    />
                  )}
                  <DeleteIcon
                    cursor="pointer"
                    onClick={() =>
                      handleDeleteJob(row?.idHangfireJob, row?.nmJob)
                    }
                  />
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
    </>
  )
}

export default TableJobs
